export const FileSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
    <rect width="56" height="56" rx="6" fill="#F3EFFF" />
    <mask id="mask0_1704_30826" maskUnits="userSpaceOnUse" x="16" y="16" width="24" height="24">
      <rect x="16" y="16" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1704_30826)">
      <path
        d="M21 37C20.45 37 19.9792 36.8042 19.5875 36.4125C19.1958 36.0208 19 35.55 19 35V21C19 20.45 19.1958 19.9792 19.5875 19.5875C19.9792 19.1958 20.45 19 21 19H32L37 24V35C37 35.55 36.8042 36.0208 36.4125 36.4125C36.0208 36.8042 35.55 37 35 37H21ZM21 35H35V25H31V21H21V35ZM23 33H33V31H23V33ZM23 25H28V23H23V25ZM23 29H33V27H23V29Z"
        fill="#7D5AE8"
      />
    </g>
  </svg>
);

export const AddFiltersIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_4290_6405" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4290_6405)">
      <path
        d="M8.33333 15V13.3333H11.6667V15H8.33333ZM5 10.8333V9.16667H15V10.8333H5ZM2.5 6.66667V5H17.5V6.66667H2.5Z"
        fill="#303030"
      />
      <path
        d="M14.6667 15.0001V16.6704H16.3333V15.0001H18V13.3334L16.3333 13.3243V11.7031H14.6667V13.3243H13V15.0001H14.6667Z"
        fill="#303030"
      />
    </g>
  </svg>
);

export const InterviewSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
    <rect x="0.333496" width="56" height="56" rx="6" fill="#F3EFFF" />
    <mask id="mask0_1704_30835" maskUnits="userSpaceOnUse" x="16" y="16" width="25" height="24">
      <rect x="16.3335" y="16" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1704_30835)">
      <path
        d="M36.8335 32.5C36.4168 32.5 36.0627 32.3542 35.771 32.0625C35.4793 31.7708 35.3335 31.4167 35.3335 31V28.5C35.3335 28.0833 35.4793 27.7292 35.771 27.4375C36.0627 27.1458 36.4168 27 36.8335 27C37.2502 27 37.6043 27.1458 37.896 27.4375C38.1877 27.7292 38.3335 28.0833 38.3335 28.5V31C38.3335 31.4167 38.1877 31.7708 37.896 32.0625C37.6043 32.3542 37.2502 32.5 36.8335 32.5ZM36.3335 36V34.45C35.4835 34.3167 34.771 33.9292 34.196 33.2875C33.621 32.6458 33.3335 31.8833 33.3335 31H34.3335C34.3335 31.7 34.5752 32.2917 35.0585 32.775C35.5418 33.2583 36.1335 33.5 36.8335 33.5C37.5335 33.5 38.1252 33.2583 38.6085 32.775C39.0918 32.2917 39.3335 31.7 39.3335 31H40.3335C40.3335 31.8833 40.046 32.6458 39.471 33.2875C38.896 33.9292 38.1835 34.3167 37.3335 34.45V36H36.3335ZM25.3335 28C24.2335 28 23.2918 27.6083 22.5085 26.825C21.7252 26.0417 21.3335 25.1 21.3335 24C21.3335 22.9 21.7252 21.9583 22.5085 21.175C23.2918 20.3917 24.2335 20 25.3335 20C25.5668 20 25.796 20.0167 26.021 20.05C26.246 20.0833 26.4668 20.1417 26.6835 20.225C26.2502 20.7417 25.9168 21.3208 25.6835 21.9625C25.4502 22.6042 25.3335 23.2833 25.3335 24C25.3335 24.7167 25.4502 25.3958 25.6835 26.0375C25.9168 26.6792 26.2502 27.2583 26.6835 27.775C26.4668 27.8583 26.246 27.9167 26.021 27.95C25.796 27.9833 25.5668 28 25.3335 28ZM17.3335 36V33.225C17.3335 32.6583 17.4752 32.1333 17.7585 31.65C18.0418 31.1667 18.4335 30.8 18.9335 30.55C19.5668 30.2167 20.2543 29.9292 20.996 29.6875C21.7377 29.4458 22.5502 29.2583 23.4335 29.125C22.7668 29.5917 22.2502 30.1833 21.8835 30.9C21.5168 31.6167 21.3335 32.3917 21.3335 33.225V36H17.3335ZM31.3335 28C30.2335 28 29.2918 27.6083 28.5085 26.825C27.7252 26.0417 27.3335 25.1 27.3335 24C27.3335 22.9 27.7252 21.9583 28.5085 21.175C29.2918 20.3917 30.2335 20 31.3335 20C32.4335 20 33.3752 20.3917 34.1585 21.175C34.9418 21.9583 35.3335 22.9 35.3335 24C35.3335 25.1 34.9418 26.0417 34.1585 26.825C33.3752 27.6083 32.4335 28 31.3335 28ZM31.3335 26C31.8835 26 32.3543 25.8042 32.746 25.4125C33.1377 25.0208 33.3335 24.55 33.3335 24C33.3335 23.45 33.1377 22.9792 32.746 22.5875C32.3543 22.1958 31.8835 22 31.3335 22C30.7835 22 30.3127 22.1958 29.921 22.5875C29.5293 22.9792 29.3335 23.45 29.3335 24C29.3335 24.55 29.5293 25.0208 29.921 25.4125C30.3127 25.8042 30.7835 26 31.3335 26ZM23.3335 36V33.225C23.3335 32.6583 23.4752 32.1333 23.7585 31.65C24.0418 31.1667 24.4335 30.8 24.9335 30.55C25.7835 30.1167 26.746 29.75 27.821 29.45C28.896 29.15 30.0668 29 31.3335 29C31.5335 29 31.7293 29.0042 31.921 29.0125C32.1127 29.0208 32.3002 29.0333 32.4835 29.05C32.3168 29.35 32.1793 29.6625 32.071 29.9875C31.9627 30.3125 31.8918 30.65 31.8585 31H31.3335C30.1335 31 29.071 31.15 28.146 31.45C27.221 31.75 26.4585 32.05 25.8585 32.35C25.6918 32.4333 25.5627 32.5542 25.471 32.7125C25.3793 32.8708 25.3335 33.0417 25.3335 33.225V34H32.5085C32.7585 34.4333 33.0668 34.8167 33.4335 35.15C33.8002 35.4833 34.2085 35.7667 34.6585 36H23.3335Z"
        fill="#7D5AE8"
      />
    </g>
  </svg>
);

export const UserAddSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="57" height="56" viewBox="0 0 57 56" fill="none">
    <rect x="0.666504" width="56" height="56" rx="6" fill="#F3EFFF" />
    <mask
      id="mask0_1704_30844"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="16"
      y="16"
      width="25"
      height="24"
    >
      <rect x="16.6665" y="16" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1704_30844)">
      <path
        d="M35.2985 28.8935C34.9003 27.699 33.9631 26.7618 32.7686 26.3636L31.666 25.9961L32.7686 25.6285C33.9631 25.2304 34.9003 24.2931 35.2985 23.0987L35.666 21.9961L36.0336 23.0987C36.4317 24.2931 37.369 25.2304 38.5634 25.6285L39.666 25.9961L38.5634 26.3636C37.369 26.7618 36.4317 27.699 36.0336 28.8935L35.666 29.9961L35.2985 28.8935ZM25.666 27.9961C24.566 27.9961 23.6243 27.6044 22.841 26.8211C22.0577 26.0378 21.666 25.0961 21.666 23.9961C21.666 22.8961 22.0577 21.9544 22.841 21.1711C23.6243 20.3878 24.566 19.9961 25.666 19.9961C26.766 19.9961 27.7077 20.3878 28.491 21.1711C29.2743 21.9544 29.666 22.8961 29.666 23.9961C29.666 25.0961 29.2743 26.0378 28.491 26.8211C27.7077 27.6044 26.766 27.9961 25.666 27.9961ZM17.666 36V33.225C17.666 32.6583 17.8118 32.1333 18.1035 31.65C18.3952 31.1667 18.7827 30.8 19.266 30.55C20.2993 30.0294 21.3493 29.6419 22.416 29.3836C23.4827 29.1253 24.566 28.9961 25.666 28.9961C26.766 28.9961 27.8493 29.1253 28.916 29.3836C29.9827 29.6419 31.0327 30.0294 32.066 30.5461C32.5493 30.7961 32.9368 31.1586 33.2285 31.6336C33.5202 32.1086 33.666 32.6294 33.666 33.1961V35.9961H17.666ZM19.666 33.9961H31.666V33.1961C31.666 33.0128 31.6202 32.8461 31.5285 32.6961C31.4368 32.5461 31.316 32.4294 31.166 32.3461C30.266 31.8961 29.3577 31.5586 28.441 31.3336C27.5243 31.1086 26.5993 30.9961 25.666 30.9961C24.7327 30.9961 23.8077 31.1086 22.891 31.3336C21.9743 31.5586 21.066 31.8961 20.166 32.3461C20.016 32.4294 19.8952 32.5461 19.8035 32.6961C19.7118 32.8461 19.666 33.0128 19.666 33.1961V33.9961ZM25.666 25.9961C26.216 25.9961 26.6868 25.8003 27.0785 25.4086C27.4702 25.0169 27.666 24.5461 27.666 23.9961C27.666 23.4461 27.4702 22.9753 27.0785 22.5836C26.6868 22.1919 26.216 21.9961 25.666 21.9961C25.116 21.9961 24.6452 22.1919 24.2535 22.5836C23.8618 22.9753 23.666 23.4461 23.666 23.9961C23.666 24.5461 23.8618 25.0169 24.2535 25.4086C24.6452 25.8003 25.116 25.9961 25.666 25.9961Z"
        fill="#7D5AE8"
      />
    </g>
  </svg>
);

export const QuestionSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <mask id="mask0_2857_107193" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2857_107193)">
      <path
        d="M12 22L11.75 19H11.5C9.13333 19 7.125 18.175 5.475 16.525C3.825 14.875 3 12.8667 3 10.5C3 8.13333 3.825 6.125 5.475 4.475C7.125 2.825 9.13333 2 11.5 2C12.6833 2 13.7875 2.22083 14.8125 2.6625C15.8375 3.10417 16.7375 3.7125 17.5125 4.4875C18.2875 5.2625 18.8958 6.1625 19.3375 7.1875C19.7792 8.2125 20 9.31667 20 10.5C20 11.75 19.7958 12.95 19.3875 14.1C18.9792 15.25 18.4208 16.3167 17.7125 17.3C17.0042 18.2833 16.1625 19.175 15.1875 19.975C14.2125 20.775 13.15 21.45 12 22ZM14 18.35C15.1833 17.35 16.1458 16.1792 16.8875 14.8375C17.6292 13.4958 18 12.05 18 10.5C18 8.68333 17.3708 7.14583 16.1125 5.8875C14.8542 4.62917 13.3167 4 11.5 4C9.68333 4 8.14583 4.62917 6.8875 5.8875C5.62917 7.14583 5 8.68333 5 10.5C5 12.3167 5.62917 13.8542 6.8875 15.1125C8.14583 16.3708 9.68333 17 11.5 17H14V18.35ZM11.475 15.975C11.7583 15.975 12 15.875 12.2 15.675C12.4 15.475 12.5 15.2333 12.5 14.95C12.5 14.6667 12.4 14.425 12.2 14.225C12 14.025 11.7583 13.925 11.475 13.925C11.1917 13.925 10.95 14.025 10.75 14.225C10.55 14.425 10.45 14.6667 10.45 14.95C10.45 15.2333 10.55 15.475 10.75 15.675C10.95 15.875 11.1917 15.975 11.475 15.975ZM10.75 12.8H12.25C12.25 12.3 12.3 11.95 12.4 11.75C12.5 11.55 12.8167 11.1833 13.35 10.65C13.65 10.35 13.9 10.025 14.1 9.675C14.3 9.325 14.4 8.95 14.4 8.55C14.4 7.7 14.1125 7.0625 13.5375 6.6375C12.9625 6.2125 12.2833 6 11.5 6C10.7667 6 10.15 6.20417 9.65 6.6125C9.15 7.02083 8.8 7.51667 8.6 8.1L10 8.65C10.0833 8.36667 10.2417 8.0875 10.475 7.8125C10.7083 7.5375 11.05 7.4 11.5 7.4C11.95 7.4 12.2875 7.525 12.5125 7.775C12.7375 8.025 12.85 8.3 12.85 8.6C12.85 8.88333 12.7667 9.1375 12.6 9.3625C12.4333 9.5875 12.2333 9.81667 12 10.05C11.4167 10.55 11.0625 10.9458 10.9375 11.2375C10.8125 11.5292 10.75 12.05 10.75 12.8Z"
        fill="#303030"
      />
    </g>
  </svg>
);

export const CheckCircleIcons = () => (
  <svg width="96" height="97" viewBox="0 0 96 97" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.625" width="96" height="96" rx="48" fill="#ECFDF3" />
    <rect x="16" y="16.625" width="64" height="64" rx="32" fill="#D1FADF" />
    <mask id="mask0_7891_144779" maskUnits="userSpaceOnUse" x="32" y="32" width="32" height="33">
      <rect x="32" y="32.625" width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7891_144779)">
      <path
        d="M46.1332 54.7596L55.5332 45.3596L53.6665 43.493L46.1332 51.0263L42.3332 47.2263L40.4665 49.093L46.1332 54.7596ZM47.9998 61.9596C46.1554 61.9596 44.4221 61.6096 42.7998 60.9096C41.1776 60.2096 39.7665 59.2596 38.5665 58.0596C37.3665 56.8596 36.4165 55.4485 35.7165 53.8263C35.0165 52.2041 34.6665 50.4707 34.6665 48.6263C34.6665 46.7819 35.0165 45.0485 35.7165 43.4263C36.4165 41.8041 37.3665 40.393 38.5665 39.193C39.7665 37.993 41.1776 37.043 42.7998 36.343C44.4221 35.643 46.1554 35.293 47.9998 35.293C49.8443 35.293 51.5776 35.643 53.1998 36.343C54.8221 37.043 56.2332 37.993 57.4332 39.193C58.6332 40.393 59.5832 41.8041 60.2832 43.4263C60.9832 45.0485 61.3332 46.7819 61.3332 48.6263C61.3332 50.4707 60.9832 52.2041 60.2832 53.8263C59.5832 55.4485 58.6332 56.8596 57.4332 58.0596C56.2332 59.2596 54.8221 60.2096 53.1998 60.9096C51.5776 61.6096 49.8443 61.9596 47.9998 61.9596Z"
        fill="#039855"
      />
    </g>
  </svg>
);

export const CrownSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <rect width="36" height="36" rx="18" fill="#333333" />
    <mask id="mask0_3800_54478" maskUnits="userSpaceOnUse" x="6" y="6" width="24" height="24">
      <rect x="6" y="6" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3800_54478)">
      <path
        d="M11 26V24H25V26H11ZM11 22.5L9.725 14.475C9.69167 14.475 9.65417 14.4792 9.6125 14.4875C9.57083 14.4958 9.53333 14.5 9.5 14.5C9.08333 14.5 8.72917 14.3542 8.4375 14.0625C8.14583 13.7708 8 13.4167 8 13C8 12.5833 8.14583 12.2292 8.4375 11.9375C8.72917 11.6458 9.08333 11.5 9.5 11.5C9.91667 11.5 10.2708 11.6458 10.5625 11.9375C10.8542 12.2292 11 12.5833 11 13C11 13.1167 10.9875 13.225 10.9625 13.325C10.9375 13.425 10.9083 13.5167 10.875 13.6L14 15L17.125 10.725C16.9417 10.5917 16.7917 10.4167 16.675 10.2C16.5583 9.98333 16.5 9.75 16.5 9.5C16.5 9.08333 16.6458 8.72917 16.9375 8.4375C17.2292 8.14583 17.5833 8 18 8C18.4167 8 18.7708 8.14583 19.0625 8.4375C19.3542 8.72917 19.5 9.08333 19.5 9.5C19.5 9.75 19.4417 9.98333 19.325 10.2C19.2083 10.4167 19.0583 10.5917 18.875 10.725L22 15L25.125 13.6C25.0917 13.5167 25.0625 13.425 25.0375 13.325C25.0125 13.225 25 13.1167 25 13C25 12.5833 25.1458 12.2292 25.4375 11.9375C25.7292 11.6458 26.0833 11.5 26.5 11.5C26.9167 11.5 27.2708 11.6458 27.5625 11.9375C27.8542 12.2292 28 12.5833 28 13C28 13.4167 27.8542 13.7708 27.5625 14.0625C27.2708 14.3542 26.9167 14.5 26.5 14.5C26.4667 14.5 26.4292 14.4958 26.3875 14.4875C26.3458 14.4792 26.3083 14.475 26.275 14.475L25 22.5H11Z"
        fill="white"
      />
    </g>
  </svg>
);

export const UserMic = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_1692_28776" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1692_28776)">
        <path
          d="M20.4989 16.4989C20.0822 16.4989 19.7281 16.3531 19.4364 16.0614C19.1447 15.7697 18.9989 15.4156 18.9989 14.9989V12.4989C18.9989 12.0822 19.1447 11.7281 19.4364 11.4364C19.7281 11.1447 20.0822 10.9989 20.4989 10.9989C20.9156 10.9989 21.2697 11.1447 21.5614 11.4364C21.8531 11.7281 21.9989 12.0822 21.9989 12.4989V14.9989C21.9989 15.4156 21.8531 15.7697 21.5614 16.0614C21.2697 16.3531 20.9156 16.4989 20.4989 16.4989ZM19.9989 19.9989V18.4489C19.1489 18.3156 18.4364 17.9281 17.8614 17.2864C17.2864 16.6447 16.9989 15.8822 16.9989 14.9989H17.9989C17.9989 15.6989 18.2406 16.2906 18.7239 16.7739C19.2072 17.2572 19.7989 17.4989 20.4989 17.4989C21.1989 17.4989 21.7906 17.2572 22.2739 16.7739C22.7572 16.2906 22.9989 15.6989 22.9989 14.9989H23.9989C23.9989 15.8822 23.7114 16.6447 23.1364 17.2864C22.5614 17.9281 21.8489 18.3156 20.9989 18.4489V19.9989H19.9989ZM8.9989 11.9989C7.8989 11.9989 6.95723 11.6072 6.1739 10.8239C5.39057 10.0406 4.9989 9.0989 4.9989 7.9989C4.9989 6.8989 5.39057 5.95723 6.1739 5.1739C6.95723 4.39057 7.8989 3.9989 8.9989 3.9989C9.23223 3.9989 9.4614 4.01557 9.6864 4.0489C9.9114 4.08223 10.1322 4.14057 10.3489 4.2239C9.91557 4.74057 9.58224 5.31973 9.3489 5.9614C9.11557 6.60307 8.9989 7.28223 8.9989 7.9989C8.9989 8.71557 9.11557 9.39473 9.3489 10.0364C9.58224 10.6781 9.91557 11.2572 10.3489 11.7739C10.1322 11.8572 9.9114 11.9156 9.6864 11.9489C9.4614 11.9822 9.23223 11.9989 8.9989 11.9989ZM0.998901 19.9989V17.2239C0.998901 16.6572 1.14057 16.1322 1.4239 15.6489C1.70723 15.1656 2.0989 14.7989 2.5989 14.5489C3.23223 14.2156 3.91973 13.9281 4.6614 13.6864C5.40307 13.4447 6.21557 13.2572 7.0989 13.1239C6.43223 13.5906 5.91557 14.1822 5.5489 14.8989C5.18223 15.6156 4.9989 16.3906 4.9989 17.2239V19.9989H0.998901ZM14.9989 11.9989C13.8989 11.9989 12.9572 11.6072 12.1739 10.8239C11.3906 10.0406 10.9989 9.0989 10.9989 7.9989C10.9989 6.8989 11.3906 5.95723 12.1739 5.1739C12.9572 4.39057 13.8989 3.9989 14.9989 3.9989C16.0989 3.9989 17.0406 4.39057 17.8239 5.1739C18.6072 5.95723 18.9989 6.8989 18.9989 7.9989C18.9989 9.0989 18.6072 10.0406 17.8239 10.8239C17.0406 11.6072 16.0989 11.9989 14.9989 11.9989ZM14.9989 9.9989C15.5489 9.9989 16.0197 9.80307 16.4114 9.4114C16.8031 9.01973 16.9989 8.5489 16.9989 7.9989C16.9989 7.4489 16.8031 6.97807 16.4114 6.5864C16.0197 6.19473 15.5489 5.9989 14.9989 5.9989C14.4489 5.9989 13.9781 6.19473 13.5864 6.5864C13.1947 6.97807 12.9989 7.4489 12.9989 7.9989C12.9989 8.5489 13.1947 9.01973 13.5864 9.4114C13.9781 9.80307 14.4489 9.9989 14.9989 9.9989ZM6.9989 19.9989V17.2239C6.9989 16.6572 7.14057 16.1322 7.4239 15.6489C7.70723 15.1656 8.0989 14.7989 8.5989 14.5489C9.4489 14.1156 10.4114 13.7489 11.4864 13.4489C12.5614 13.1489 13.7322 12.9989 14.9989 12.9989C15.1989 12.9989 15.3947 13.0031 15.5864 13.0114C15.7781 13.0197 15.9656 13.0322 16.1489 13.0489C15.9822 13.3489 15.8447 13.6614 15.7364 13.9864C15.6281 14.3114 15.5572 14.6489 15.5239 14.9989H14.9989C13.7989 14.9989 12.7364 15.1489 11.8114 15.4489C10.8864 15.7489 10.1239 16.0489 9.5239 16.3489C9.35723 16.4322 9.22807 16.5531 9.1364 16.7114C9.04473 16.8697 8.9989 17.0406 8.9989 17.2239V17.9989H16.1739C16.4239 18.4322 16.7322 18.8156 17.0989 19.1489C17.4656 19.4822 17.8739 19.7656 18.3239 19.9989H6.9989Z"
          fill={'#303030'}
        />
      </g>
    </svg>
  );
};

export const UserPlus = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
      <path
        d="M17.6314 8.89627C17.2332 7.70185 16.296 6.76459 15.1015 6.36645L13.9989 5.9989L15.1015 5.63136C16.296 5.23322 17.2332 4.29595 17.6314 3.10153L17.9989 1.9989L18.3664 3.10153C18.7646 4.29595 19.7018 5.23322 20.8963 5.63136L21.9989 5.9989L20.8963 6.36645C19.7018 6.76459 18.7646 7.70185 18.3664 8.89627L17.9989 9.9989L17.6314 8.89627ZM7.9989 7.9989C6.8989 7.9989 5.95723 7.60723 5.1739 6.8239C4.39057 6.04057 3.9989 5.0989 3.9989 3.9989C3.9989 2.8989 4.39057 1.95723 5.1739 1.1739C5.95723 0.390568 6.8989 -0.00109863 7.9989 -0.00109863C9.0989 -0.00109863 10.0406 0.390568 10.8239 1.1739C11.6072 1.95723 11.9989 2.8989 11.9989 3.9989C11.9989 5.0989 11.6072 6.04057 10.8239 6.8239C10.0406 7.60723 9.0989 7.9989 7.9989 7.9989ZM-0.00109863 15.9989V13.1989C-0.00109863 12.6322 0.144735 12.1114 0.436401 11.6364C0.728068 11.1614 1.11557 10.7989 1.5989 10.5489C2.63223 10.0322 3.68223 9.64473 4.7489 9.3864C5.81557 9.12807 6.8989 8.9989 7.9989 8.9989C9.0989 8.9989 10.1822 9.12807 11.2489 9.3864C12.3156 9.64473 13.3656 10.0322 14.3989 10.5489C14.8822 10.7989 15.2697 11.1614 15.5614 11.6364C15.8531 12.1114 15.9989 12.6322 15.9989 13.1989V15.9989H-0.00109863ZM1.9989 13.9989H13.9989V13.1989C13.9989 13.0156 13.9531 12.8489 13.8614 12.6989C13.7697 12.5489 13.6489 12.4322 13.4989 12.3489C12.5989 11.8989 11.6906 11.5614 10.7739 11.3364C9.85723 11.1114 8.93223 10.9989 7.9989 10.9989C7.06557 10.9989 6.14057 11.1114 5.2239 11.3364C4.30723 11.5614 3.3989 11.8989 2.4989 12.3489C2.3489 12.4322 2.22807 12.5489 2.1364 12.6989C2.04473 12.8489 1.9989 13.0156 1.9989 13.1989V13.9989ZM7.9989 5.9989C8.5489 5.9989 9.01974 5.80307 9.4114 5.4114C9.80307 5.01973 9.9989 4.5489 9.9989 3.9989C9.9989 3.4489 9.80307 2.97807 9.4114 2.5864C9.01974 2.19473 8.5489 1.9989 7.9989 1.9989C7.4489 1.9989 6.97807 2.19473 6.5864 2.5864C6.19473 2.97807 5.9989 3.4489 5.9989 3.9989C5.9989 4.5489 6.19473 5.01973 6.5864 5.4114C6.97807 5.80307 7.4489 5.9989 7.9989 5.9989Z"
        fill="#303030"
      />
    </svg>
  );
};
export const UserMic2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_2857_104379" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2857_104379)">
        <path
          d="M23 14H18.425C18.375 13.65 18.2958 13.3083 18.1875 12.975C18.0792 12.6417 17.9417 12.3167 17.775 12H20.925C20.8583 11.8833 20.7833 11.7833 20.7 11.7C20.6167 11.6167 20.5167 11.5417 20.4 11.475C19.9667 11.225 19.4708 11.0417 18.9125 10.925C18.3542 10.8083 17.7167 10.75 17 10.75H16.925C16.5917 10.3667 16.2292 10.0333 15.8375 9.75C15.4458 9.46667 15.0167 9.225 14.55 9.025C14.9333 8.94167 15.3292 8.875 15.7375 8.825C16.1458 8.775 16.5667 8.75 17 8.75C17.8833 8.75 18.7083 8.84167 19.475 9.025C20.2417 9.20833 20.9583 9.475 21.625 9.825C22.0583 10.0583 22.3958 10.4042 22.6375 10.8625C22.8792 11.3208 23 11.8417 23 12.425V14ZM17 8C16.1667 8 15.4583 7.70833 14.875 7.125C14.2917 6.54167 14 5.83333 14 5C14 4.16667 14.2917 3.45833 14.875 2.875C15.4583 2.29167 16.1667 2 17 2C17.8333 2 18.5417 2.29167 19.125 2.875C19.7083 3.45833 20 4.16667 20 5C20 5.83333 19.7083 6.54167 19.125 7.125C18.5417 7.70833 17.8333 8 17 8ZM17 6C17.2833 6 17.5208 5.90417 17.7125 5.7125C17.9042 5.52083 18 5.28333 18 5C18 4.71667 17.9042 4.47917 17.7125 4.2875C17.5208 4.09583 17.2833 4 17 4C16.7167 4 16.4792 4.09583 16.2875 4.2875C16.0958 4.47917 16 4.71667 16 5C16 5.28333 16.0958 5.52083 16.2875 5.7125C16.4792 5.90417 16.7167 6 17 6ZM1 14V12.425C1 11.8417 1.12083 11.3208 1.3625 10.8625C1.60417 10.4042 1.94167 10.0583 2.375 9.825C3.04167 9.475 3.75833 9.20833 4.525 9.025C5.29167 8.84167 6.11667 8.75 7 8.75C7.43333 8.75 7.85417 8.775 8.2625 8.825C8.67083 8.875 9.06667 8.94167 9.45 9.025C8.98333 9.225 8.55417 9.46667 8.1625 9.75C7.77083 10.0333 7.40833 10.3667 7.075 10.75H7C6.28333 10.75 5.64583 10.8083 5.0875 10.925C4.52917 11.0417 4.03333 11.225 3.6 11.475C3.48333 11.5417 3.38333 11.6167 3.3 11.7C3.21667 11.7833 3.14167 11.8833 3.075 12H6.225C6.05833 12.3167 5.92083 12.6417 5.8125 12.975C5.70417 13.3083 5.625 13.65 5.575 14H1ZM7 8C6.16667 8 5.45833 7.70833 4.875 7.125C4.29167 6.54167 4 5.83333 4 5C4 4.16667 4.29167 3.45833 4.875 2.875C5.45833 2.29167 6.16667 2 7 2C7.83333 2 8.54167 2.29167 9.125 2.875C9.70833 3.45833 10 4.16667 10 5C10 5.83333 9.70833 6.54167 9.125 7.125C8.54167 7.70833 7.83333 8 7 8ZM7 6C7.28333 6 7.52083 5.90417 7.7125 5.7125C7.90417 5.52083 8 5.28333 8 5C8 4.71667 7.90417 4.47917 7.7125 4.2875C7.52083 4.09583 7.28333 4 7 4C6.71667 4 6.47917 4.09583 6.2875 4.2875C6.09583 4.47917 6 4.71667 6 5C6 5.28333 6.09583 5.52083 6.2875 5.7125C6.47917 5.90417 6.71667 6 7 6ZM12 17C11.45 17 10.9792 16.8042 10.5875 16.4125C10.1958 16.0208 10 15.55 10 15V12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12V15C14 15.55 13.8042 16.0208 13.4125 16.4125C13.0208 16.8042 12.55 17 12 17ZM11.25 22V19.95C10.05 19.7667 9.04167 19.2083 8.225 18.275C7.40833 17.3417 7 16.25 7 15H8.5C8.5 15.9667 8.84167 16.7917 9.525 17.475C10.2083 18.1583 11.0333 18.5 12 18.5C12.9667 18.5 13.7917 18.1583 14.475 17.475C15.1583 16.7917 15.5 15.9667 15.5 15H17C17 16.25 16.5917 17.3417 15.775 18.275C14.9583 19.2083 13.95 19.7667 12.75 19.95V22H11.25Z"
          fill="#303030"
        />
      </g>
    </svg>
  );
};

export const CoinSVG = ({ width = 40, height = 40 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 40 40" fill="none">
      <g>
        <g filter="url(#filter0_i)">
          <path
            d="M20 35.57C28.6 35.57 35.57 28.6 35.57 20C35.57 11.4 28.6 4.43 20 4.43C11.4 4.43 4.43 11.4 4.43 20C4.43 28.6 11.4 35.57 20 35.57Z"
            fill="url(#paint0_linear)"
          />
        </g>
        <g filter="url(#filter1_iiii)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40ZM20 35.57C28.6 35.57 35.57 28.6 35.57 20C35.57 11.4 28.6 4.43 20 4.43C11.4 4.43 4.43 11.4 4.43 20C4.43 28.6 11.4 35.57 20 35.57"
            fill="url(#paint1_linear)"
          />
        </g>
        <mask id="mask0" maskUnits="userSpaceOnUse" x="10" y="10" width="20" height="20">
          <rect x="10" y="10" width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0)">
          <path
            d="M19.18 27.5V25.71C18.45 25.54 17.81 25.22 17.28 24.75C16.74 24.28 16.35 23.61 16.1 22.75L17.64 22.13C17.85 22.79 18.16 23.3 18.57 23.65C18.98 24 19.52 24.17 20.18 24.17C20.75 24.17 21.24 24.04 21.63 23.78C22.03 23.52 22.23 23.13 22.23 22.58C22.23 22.1 22.07 21.71 21.77 21.43C21.46 21.14 20.75 20.82 19.64 20.46C18.45 20.08 17.63 19.64 17.18 19.11C16.74 18.59 16.52 17.96 16.52 17.21C16.52 16.31 16.81 15.6 17.39 15.1C17.98 14.6 18.57 14.32 19.18 14.25V12.5H20.85V14.25C21.54 14.36 22.12 14.61 22.57 15.01C23.02 15.41 23.35 15.89 23.56 16.46L22.02 17.13C21.85 16.68 21.61 16.35 21.31 16.12C21 15.9 20.59 15.79 20.06 15.79C19.45 15.79 18.98 15.93 18.66 16.2C18.34 16.47 18.18 16.81 18.18 17.21C18.18 17.67 18.39 18.03 18.81 18.29C19.23 18.56 19.95 18.83 20.98 19.13C21.93 19.4 22.66 19.84 23.15 20.45C23.65 21.05 23.89 21.75 23.89 22.54C23.89 23.53 23.6 24.28 23.02 24.79C22.43 25.31 21.71 25.63 20.85 25.75V27.5H19.18Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i"
          x="4.3"
          y="4.43"
          width="31.27"
          height="31.27"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.125" dy="0.125" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.294 0 0 0 0 0.212 0 0 0 0 0.549 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="filter1_iiii"
          x="-0.15"
          y="-0.15"
          width="40.3"
          height="40.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.15" dy="0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.788 0 0 0 0 0.718 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.15" dy="-0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.976 0 0 0 0 0.973 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect1_innerShadow" result="effect2_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.38 0 0 0 0 0.275 0 0 0 0 0.71 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect2_innerShadow" result="effect3_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.15" dy="0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.38 0 0 0 0 0.275 0 0 0 0 0.71 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect3_innerShadow" result="effect4_innerShadow" />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="13.65"
          y1="27.79"
          x2="30.47"
          y2="6.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A182FF" />
          <stop offset="1" stopColor="#7D5AE8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B096FF" />
          <stop offset="1" stopColor="#B096FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const BigCoinSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 40 40" fill="none">
      <g>
        <g filter="url(#filter0_i)">
          <path
            d="M20 35.57C28.6 35.57 35.57 28.6 35.57 20C35.57 11.4 28.6 4.43 20 4.43C11.4 4.43 4.43 11.4 4.43 20C4.43 28.6 11.4 35.57 20 35.57Z"
            fill="url(#paint0_linear)"
          />
        </g>
        <g filter="url(#filter1_iiii)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 40C31.05 40 40 31.05 40 20C40 8.95 31.05 0 20 0C8.95 0 0 8.95 0 20C0 31.05 8.95 40 20 40ZM20 35.57C28.6 35.57 35.57 28.6 35.57 20C35.57 11.4 28.6 4.43 20 4.43C11.4 4.43 4.43 11.4 4.43 20C4.43 28.6 11.4 35.57 20 35.57"
            fill="url(#paint1_linear)"
          />
        </g>
        <mask id="mask0" maskUnits="userSpaceOnUse" x="10" y="10" width="20" height="20">
          <rect x="10" y="10" width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0)">
          <path
            d="M19.18 27.5V25.71C18.45 25.54 17.81 25.22 17.28 24.75C16.74 24.28 16.35 23.61 16.1 22.75L17.64 22.13C17.85 22.79 18.16 23.3 18.57 23.65C18.98 24 19.52 24.17 20.18 24.17C20.75 24.17 21.24 24.04 21.63 23.78C22.03 23.52 22.23 23.13 22.23 22.58C22.23 22.1 22.07 21.71 21.77 21.43C21.46 21.14 20.75 20.82 19.64 20.46C18.45 20.08 17.63 19.64 17.18 19.11C16.74 18.59 16.52 17.96 16.52 17.21C16.52 16.31 16.81 15.6 17.39 15.1C17.98 14.6 18.57 14.32 19.18 14.25V12.5H20.85V14.25C21.54 14.36 22.12 14.61 22.57 15.01C23.02 15.41 23.35 15.89 23.56 16.46L22.02 17.13C21.85 16.68 21.61 16.35 21.31 16.12C21 15.9 20.59 15.79 20.06 15.79C19.45 15.79 18.98 15.93 18.66 16.2C18.34 16.47 18.18 16.81 18.18 17.21C18.18 17.67 18.39 18.03 18.81 18.29C19.23 18.56 19.95 18.83 20.98 19.13C21.93 19.4 22.66 19.84 23.15 20.45C23.65 21.05 23.89 21.75 23.89 22.54C23.89 23.53 23.6 24.28 23.02 24.79C22.43 25.31 21.71 25.63 20.85 25.75V27.5H19.18Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i"
          x="4.3"
          y="4.43"
          width="31.27"
          height="31.27"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.125" dy="0.125" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.294 0 0 0 0 0.212 0 0 0 0 0.549 0 0 0 1 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter
          id="filter1_iiii"
          x="-0.15"
          y="-0.15"
          width="40.3"
          height="40.3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.15" dy="0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.788 0 0 0 0 0.718 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.15" dy="-0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.976 0 0 0 0 0.973 0 0 0 0 1 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect1_innerShadow" result="effect2_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.38 0 0 0 0 0.275 0 0 0 0 0.71 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect2_innerShadow" result="effect3_innerShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-0.15" dy="0.15" />
          <feGaussianBlur stdDeviation="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.38 0 0 0 0 0.275 0 0 0 0 0.71 0 0 0 1 0" />
          <feBlend mode="normal" in2="effect3_innerShadow" result="effect4_innerShadow" />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="13.65"
          y1="27.79"
          x2="30.47"
          y2="6.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A182FF" />
          <stop offset="1" stopColor="#7D5AE8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="20"
          y1="0"
          x2="20"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B096FF" />
          <stop offset="1" stopColor="#B096FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export const SectionIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
    <path
      d="M1.66667 15.5C1.20833 15.5 0.815972 15.3368 0.489583 15.0104C0.163194 14.684 0 14.2917 0 13.8333V10.5C0 10.0417 0.163194 9.64931 0.489583 9.32292C0.815972 8.99653 1.20833 8.83333 1.66667 8.83333H13.3333C13.7917 8.83333 14.184 8.99653 14.5104 9.32292C14.8368 9.64931 15 10.0417 15 10.5H1.66667V13.8333H10V15.5H1.66667ZM1.66667 7.16667C1.20833 7.16667 0.815972 7.00347 0.489583 6.67708C0.163194 6.35069 0 5.95833 0 5.5V2.16667C0 1.70833 0.163194 1.31597 0.489583 0.989583C0.815972 0.663194 1.20833 0.5 1.66667 0.5H13.3333C13.7917 0.5 14.184 0.663194 14.5104 0.989583C14.8368 1.31597 15 1.70833 15 2.16667V5.5C15 5.95833 14.8368 6.35069 14.5104 6.67708C14.184 7.00347 13.7917 7.16667 13.3333 7.16667H1.66667ZM1.66667 5.5H13.3333V2.16667H1.66667V5.5ZM13.3333 17.1667V15.5H11.6667V13.8333H13.3333V12.1667H15V13.8333H16.6667V15.5H15V17.1667H13.3333Z"
      fill="#303030"
    />
  </svg>
);

export const AnalysisSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none">
    <rect y="0.5" width="80" height="80" rx="40" fill="#F2F2F2" />
    <mask id="mask0_2857_104118" maskUnits="userSpaceOnUse" x="24" y="24" width="32" height="33">
      <rect x="24" y="24.5" width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2857_104118)">
      <path
        d="M45.3335 51.1693V41.8359H50.6668V51.1693H45.3335ZM37.3335 51.1693V29.8359H42.6668V51.1693H37.3335ZM29.3335 51.1693V36.5026H34.6668V51.1693H29.3335Z"
        fill="#7D5AE8"
      />
    </g>
  </svg>
);

export const DownloadSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 30 30" fill="none">
    <g mask="url(#mask0_3987_41700)">
      <path
        d="M16.0002 19.3359L11.8335 15.1693L13.0002 13.9609L15.1668 16.1276V9.33594H16.8335V16.1276L19.0002 13.9609L20.1668 15.1693L16.0002 19.3359ZM11.0002 22.6693C10.5418 22.6693 10.1495 22.5061 9.82308 22.1797C9.49669 21.8533 9.3335 21.4609 9.3335 21.0026V18.5026H11.0002V21.0026H21.0002V18.5026H22.6668V21.0026C22.6668 21.4609 22.5036 21.8533 22.1772 22.1797C21.8509 22.5061 21.4585 22.6693 21.0002 22.6693H11.0002Z"
        fill="#303030"
      />
    </g>
  </svg>
);

export const FileSearchSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
    <path
      d="M10.75 18L12.75 20H2C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H11L16 6V18C16 18.3333 15.9292 18.6375 15.7875 18.9125C15.6458 19.1875 15.45 19.4167 15.2 19.6L10 14.45C9.71667 14.6333 9.40833 14.7708 9.075 14.8625C8.74167 14.9542 8.38333 15 8 15C6.9 15 5.95833 14.6083 5.175 13.825C4.39167 13.0417 4 12.1 4 11C4 9.9 4.39167 8.95833 5.175 8.175C5.95833 7.39167 6.9 7 8 7C9.1 7 10.0417 7.39167 10.825 8.175C11.6083 8.95833 12 9.9 12 11C12 11.3833 11.9542 11.7417 11.8625 12.075C11.7708 12.4083 11.6333 12.7167 11.45 13L14 15.6V6.7L10.05 2H2V18H10.75ZM8 13C8.55 13 9.02083 12.8042 9.4125 12.4125C9.80417 12.0208 10 11.55 10 11C10 10.45 9.80417 9.97917 9.4125 9.5875C9.02083 9.19583 8.55 9 8 9C7.45 9 6.97917 9.19583 6.5875 9.5875C6.19583 9.97917 6 10.45 6 11C6 11.55 6.19583 12.0208 6.5875 12.4125C6.97917 12.8042 7.45 13 8 13Z"
      fill="#303030"
    />
  </svg>
);

export const PieSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
    <mask id="mask0_4204_9615" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="24">
      <rect x="0.333496" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4204_9615)">
      <path
        d="M12.3335 22C10.9502 22 9.65016 21.7375 8.4335 21.2125C7.21683 20.6875 6.1585 19.975 5.2585 19.075C4.3585 18.175 3.646 17.1167 3.121 15.9C2.596 14.6833 2.3335 13.3833 2.3335 12C2.3335 10.6167 2.596 9.31667 3.121 8.1C3.646 6.88333 4.3585 5.825 5.2585 4.925C6.1585 4.025 7.21683 3.3125 8.4335 2.7875C9.65016 2.2625 10.9502 2 12.3335 2C13.7168 2 15.0168 2.2625 16.2335 2.7875C17.4502 3.3125 18.5085 4.025 19.4085 4.925C20.3085 5.825 21.021 6.88333 21.546 8.1C22.071 9.31667 22.3335 10.6167 22.3335 12C22.3335 13.3833 22.071 14.6833 21.546 15.9C21.021 17.1167 20.3085 18.175 19.4085 19.075C18.5085 19.975 17.4502 20.6875 16.2335 21.2125C15.0168 21.7375 13.7168 22 12.3335 22ZM12.3335 20C13.4002 20 14.4252 19.8 15.4085 19.4C16.3918 19 17.2585 18.425 18.0085 17.675L12.3335 12V4C10.1002 4 8.2085 4.775 6.6585 6.325C5.1085 7.875 4.3335 9.76667 4.3335 12C4.3335 14.2333 5.1085 16.125 6.6585 17.675C8.2085 19.225 10.1002 20 12.3335 20Z"
        fill="#545454"
      />
    </g>
  </svg>
);

export const ExpandSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="mask0_4356_55368" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4356_55368)">
      <path
        d="M2.5 17.5V12.5H4.16667V14.6667L6.75 12.0833L7.91667 13.25L5.33333 15.8333H7.5V17.5H2.5ZM13.25 7.91667L12.0833 6.75L14.6667 4.16667H12.5V2.5H17.5V7.5H15.8333V5.33333L13.25 7.91667Z"
        fill="#303030"
      />
    </g>
  </svg>
);

export const FileAddSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <mask id="mask0_4463_57794" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4463_57794)">
      <path
        d="M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V9.75C17.2361 9.625 16.9653 9.51736 16.6875 9.42708C16.4097 9.33681 16.125 9.27083 15.8333 9.22917V4.16667H4.16667V15.8333H9.20833C9.25 16.1389 9.31597 16.4306 9.40625 16.7083C9.49653 16.9861 9.60417 17.25 9.72917 17.5H4.16667ZM4.16667 15.8333V4.16667V9.22917V9.16667V15.8333ZM5.83333 14.1667H9.22917C9.27083 13.875 9.33681 13.5903 9.42708 13.3125C9.51736 13.0347 9.61806 12.7639 9.72917 12.5H5.83333V14.1667ZM5.83333 10.8333H10.9167C11.3611 10.4167 11.8576 10.0694 12.4062 9.79167C12.9549 9.51389 13.5417 9.32639 14.1667 9.22917V9.16667H5.83333V10.8333ZM5.83333 7.5H14.1667V5.83333H5.83333V7.5ZM15 19.1667C13.8472 19.1667 12.8646 18.7604 12.0521 17.9479C11.2396 17.1354 10.8333 16.1528 10.8333 15C10.8333 13.8472 11.2396 12.8646 12.0521 12.0521C12.8646 11.2396 13.8472 10.8333 15 10.8333C16.1528 10.8333 17.1354 11.2396 17.9479 12.0521C18.7604 12.8646 19.1667 13.8472 19.1667 15C19.1667 16.1528 18.7604 17.1354 17.9479 17.9479C17.1354 18.7604 16.1528 19.1667 15 19.1667ZM14.5833 17.5H15.4167V15.4167H17.5V14.5833H15.4167V12.5H14.5833V14.5833H12.5V15.4167H14.5833V17.5Z"
        fill="#303030"
      />
    </g>
  </svg>
);
export const TreeMapSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <mask id="mask0_2857_109513" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2857_109513)">
      <path
        d="M4 20V17H8V20H4ZM4 16V12H8V16H4ZM4 11V4H8V11H4ZM10 20V13H14V20H10ZM10 12V8H14V12H10ZM10 7V4H14V7H10ZM16 20V18H20V20H16ZM16 17V13H20V17H16ZM16 12V4H20V12H16Z"
        fill="#545454"
      />
    </g>
  </svg>
);
export const SankySVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <mask id="mask0_2857_109708" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2857_109708)">
      <path
        d="M15 20V18H11V13H9V15H2V9H9V11H11V6H15V4H22V10H15V8H13V16H15V14H22V20H15ZM17 18H20V16H17V18ZM4 13H7V11H4V13ZM17 8H20V6H17V8Z"
        fill="#545454"
      />
    </g>
  </svg>
);

export const CheckedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 22 22" fill="none">
      <rect width="20" height="20" rx="4" fill="#7D5AE8" />
      <mask id="mask0_939_14559" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_939_14559)">
        <path
          d="M8.33333 13.6667L5 10.3333L6.16667 9.16668L8.33333 11.3333L13.8333 5.83334L15 7.00001L8.33333 13.6667Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export const UnCheckedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 20 20" fill="none">
      <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" stroke="#B5B5B5" />
    </svg>
  );
};

export const RadioCheckedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#7D5AE8" />
      <circle cx="10" cy="10" r="4" fill="white" />
    </svg>
  );
};
export const ArrowDownSVG = () => {
  return (
    <svg
      className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiSelect-icon MuiSelect-iconOutlined css-hfutr2-MuiSvgIcon-root-MuiSelect-icon"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      data-testid="ArrowDropDownIcon"
    >
      <path d="M7 10l5 5 5-5z"></path>
    </svg>
  );
};

export const CategorySVG = ({ width = 24, height = 24, color = '#303030' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g mask="url(#mask0_2139_85461)">
        <path
          d="M17.75 20.25C16.7 20.25 15.8125 19.8875 15.0875 19.1625C14.3625 18.4375 14 17.55 14 16.5C14 15.45 14.3625 14.5625 15.0875 13.8375C15.8125 13.1125 16.7 12.75 17.75 12.75C18.8 12.75 19.6875 13.1125 20.4125 13.8375C21.1375 14.5625 21.5 15.45 21.5 16.5C21.5 17.55 21.1375 18.4375 20.4125 19.1625C19.6875 19.8875 18.8 20.25 17.75 20.25ZM17.75 18.25C18.2333 18.25 18.6458 18.0792 18.9875 17.7375C19.3292 17.3958 19.5 16.9833 19.5 16.5C19.5 16.0167 19.3292 15.6042 18.9875 15.2625C18.6458 14.9208 18.2333 14.75 17.75 14.75C17.2667 14.75 16.8542 14.9208 16.5125 15.2625C16.1708 15.6042 16 16.0167 16 16.5C16 16.9833 16.1708 17.3958 16.5125 17.7375C16.8542 18.0792 17.2667 18.25 17.75 18.25ZM4 17.5V15.5H12V17.5H4ZM6.25 11.25C5.2 11.25 4.3125 10.8875 3.5875 10.1625C2.8625 9.4375 2.5 8.55 2.5 7.5C2.5 6.45 2.8625 5.5625 3.5875 4.8375C4.3125 4.1125 5.2 3.75 6.25 3.75C7.3 3.75 8.1875 4.1125 8.9125 4.8375C9.6375 5.5625 10 6.45 10 7.5C10 8.55 9.6375 9.4375 8.9125 10.1625C8.1875 10.8875 7.3 11.25 6.25 11.25ZM6.25 9.25C6.73333 9.25 7.14583 9.07917 7.4875 8.7375C7.82917 8.39583 8 7.98333 8 7.5C8 7.01667 7.82917 6.60417 7.4875 6.2625C7.14583 5.92083 6.73333 5.75 6.25 5.75C5.76667 5.75 5.35417 5.92083 5.0125 6.2625C4.67083 6.60417 4.5 7.01667 4.5 7.5C4.5 7.98333 4.67083 8.39583 5.0125 8.7375C5.35417 9.07917 5.76667 9.25 6.25 9.25ZM12 8.5V6.5H20V8.5H12Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
export const MagicSVG = ({ fill, width = 48 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M34 6C32.632 10.944 30.87 12.633 26 14C30.87 15.367 32.632 17.056 34 22C35.368 17.056 37.13 15.367 42 14C37.13 12.633 35.368 10.944 34 6ZM20 14C17.605 22.651 14.524 25.608 6 28C14.524 30.392 17.605 33.349 20 42C22.395 33.349 25.476 30.392 34 28C25.476 25.608 22.395 22.651 20 14Z"
        fill={fill || '#7D5AE8'}
      />
    </svg>
  );
};
export const LogoSVG = () => {
  return (
    <svg
      className="animated-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="264"
      height="256"
      viewBox="0 0 32 28"
      fill="none"
    >
      <g clipPath="url(#clip0_2857_112416)">
        <path
          d="M18.9032 23.5826C18.7636 23.5874 18.6192 23.5906 18.4764 23.5906C12.7679 23.5906 7.99639 20.303 6.84122 15.9141C7.78461 19.015 11.0929 21.306 15.0301 21.306C15.9238 21.306 16.7854 21.1869 17.5956 20.9695C17.9742 21.8727 18.4122 22.7454 18.9016 23.5842L18.9032 23.5826Z"
          fill="url(#paint0_linear_2857_112416)"
        />
        <path
          d="M30.3795 13.8516C30.3795 18.189 26.2722 22.214 21.4815 23.4763C20.453 22.631 19.5883 21.5942 18.7235 20.5815C21.2408 19.3337 23.4886 16.7657 23.4886 14.1092C23.4886 10.5172 20.4001 7.54193 16.3602 6.99936C15.927 6.93979 15.481 6.91081 15.0301 6.91081C14.6419 6.91081 14.26 6.93335 13.8862 6.97521C9.82542 7.44211 6.68077 10.3611 6.57328 13.924C6.57167 13.8999 6.57167 13.8757 6.57167 13.8516C6.57167 9.81367 9.57192 6.35052 13.8477 4.87252C14.8954 4.51188 16.0184 4.26877 17.1945 4.16573C17.6148 4.1287 18.0432 4.10938 18.478 4.10938C25.0529 4.10938 30.3811 8.47091 30.3811 13.8516H30.3795Z"
          fill="url(#paint1_linear_2857_112416)"
        />
        <path
          d="M27.1242 22.2497H27.1194C29.1281 19.9506 30.3908 17.0687 30.3908 14C30.3908 7.6195 25.4091 2.27424 18.7107 0.865474C17.5812 0.627191 16.4019 0.5 15.189 0.5C14.9178 0.5 14.6499 0.50483 14.382 0.51932C7.95788 0.817174 2.58952 4.66029 0.710755 9.8864C0.250288 11.337 0.00320882 12.8665 0 14.446C0.264728 21.6975 6.96315 27.5 15.189 27.5C17.2186 27.5 19.1551 27.1458 20.9231 26.505C20.1771 25.5905 19.5 24.6116 18.9016 23.5844C18.762 23.5893 18.6176 23.5925 18.4748 23.5925C12.7663 23.5925 7.99479 20.3048 6.83961 15.9159C6.83801 15.9143 6.8364 15.9111 6.8364 15.9063C6.66312 15.3315 6.57007 14.7277 6.57007 14.1079C6.57007 14.0563 6.57007 14.0048 6.57167 13.9549C6.57007 13.9436 6.57007 13.934 6.57167 13.9227C6.57007 13.8986 6.57007 13.8744 6.57007 13.8503C6.57007 9.81234 9.57192 6.3492 13.8461 4.8712C14.8938 4.51055 16.0168 4.26744 17.1929 4.1644C17.6132 4.12737 18.0416 4.10966 18.4764 4.10966C25.0513 4.10966 30.3795 8.4712 30.3795 13.8519C30.3795 18.1893 26.2722 22.2143 21.4815 23.4766C23.7806 25.4649 26.0091 26.703 27.559 27.4066C29.8854 26.4052 32 24.2043 32 24.2043C28.9276 23.615 27.1242 22.253 27.1242 22.253V22.2497Z"
          fill="url(#paint2_linear_2857_112416)"
        />
        <path
          d="M18.7251 14.2697C18.7074 14.2825 18.6898 14.2938 18.6721 14.3067C16.9699 14.5224 15.5949 15.7976 15.2259 17.4543C15.2162 17.4639 15.2082 17.4736 15.2002 17.4849C14.8392 15.8024 13.4434 14.5063 11.7138 14.3019C11.6994 14.2906 11.6817 14.2809 11.6657 14.2697C11.6785 14.2616 11.6897 14.2536 11.7026 14.2455C13.437 14.0459 14.8392 12.7482 15.2002 11.0625C15.2082 11.0738 15.2162 11.0818 15.2243 11.0915C15.5933 12.7514 16.9731 14.0298 18.6802 14.2407C18.6946 14.2503 18.709 14.26 18.7235 14.2697H18.7251Z"
          fill="url(#paint3_linear_2857_112416)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2857_112416"
          x1="26.544"
          y1="33.4012"
          x2="21.7478"
          y2="27.8252"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8963FF" />
          <stop offset="1" stopColor="#3C00AA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2857_112416"
          x1="35.965"
          y1="28.373"
          x2="23.8206"
          y2="16.8366"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8963FF" />
          <stop offset="1" stopColor="#3C00AA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2857_112416"
          x1="0"
          y1="14"
          x2="32"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8963FF" />
          <stop offset="1" stopColor="#3C00AA" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2857_112416"
          x1="23.7534"
          y1="20.2613"
          x2="23.9279"
          y2="23.882"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#8963FF" />
          <stop offset="1" stopColor="#3C00AA" />
        </linearGradient>
        <clipPath id="clip0_2857_112416">
          <rect width="32" height="27" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SendSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="16" fill="#7D5AE8" />
      <mask id="mask0_4867_44007" maskUnits="userSpaceOnUse" x="6" y="6" width="20" height="20">
        <rect x="6" y="6" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4867_44007)">
        <path
          d="M15.1667 20.9974V13.3307L12.1667 16.3307L11 15.1641L16 10.1641L21 15.1641L19.8333 16.3307L16.8333 13.3307V20.9974H15.1667Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const ColumnSVG = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_5501_57554"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5501_57554)">
        <path
          d="M3.33317 4.16667V15.8333H8.33317V4.16667H3.33317ZM1.6665 17.5V2.5H16.6665V5.83333H14.9998V4.16667H9.99984V15.8333H14.9998V14.1667H16.6665V17.5H1.6665ZM14.9998 12.5V10.8333H13.3332V9.16667H14.9998V7.5H16.6665V9.16667H18.3332V10.8333H16.6665V12.5H14.9998Z"
          fill="#303030"
        />
      </g>
    </svg>
  );
};

export const ParticipantSVG = () => {
  <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="80" height="80" rx="40" fill="#F2F2F2" />
    <mask
      id="mask0_3214_107381"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="24"
      y="24"
      width="32"
      height="33"
    >
      <rect x="24" y="24.5" width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3214_107381)">
      <path
        d="M48.6312 41.0588C48.233 39.8644 47.2958 38.9271 46.1013 38.529L43.9987 37.8281L46.1013 37.1272C47.2958 36.7291 48.233 35.7918 48.6312 34.5974L49.332 32.4948L50.0329 34.5974C50.431 35.7918 51.3683 36.7291 52.5627 37.1272L54.6654 37.8281L52.5627 38.529C51.3683 38.9271 50.431 39.8644 50.0329 41.0588L49.332 43.1615L48.6312 41.0588ZM35.9987 40.4948C34.532 40.4948 33.2765 39.9726 32.232 38.9281C31.1876 37.8837 30.6654 36.6281 30.6654 35.1615C30.6654 33.6948 31.1876 32.4392 32.232 31.3948C33.2765 30.3503 34.532 29.8281 35.9987 29.8281C37.4654 29.8281 38.7209 30.3503 39.7654 31.3948C40.8098 32.4392 41.332 33.6948 41.332 35.1615C41.332 36.6281 40.8098 37.8837 39.7654 38.9281C38.7209 39.9726 37.4654 40.4948 35.9987 40.4948ZM25.332 51.1615V47.4281C25.332 46.6726 25.5265 45.9781 25.9154 45.3448C26.3043 44.7115 26.8209 44.2281 27.4654 43.8948C28.8431 43.2059 30.2431 42.6892 31.6654 42.3448C33.0876 42.0003 34.532 41.8281 35.9987 41.8281C37.4654 41.8281 38.9098 42.0003 40.332 42.3448C41.7543 42.6892 43.1543 43.2059 44.532 43.8948C45.1765 44.2281 45.6931 44.7115 46.082 45.3448C46.4709 45.9781 46.6654 46.6726 46.6654 47.4281V51.1615H25.332ZM27.9987 48.4948H43.9987V47.4281C43.9987 47.1837 43.9376 46.9615 43.8154 46.7615C43.6931 46.5615 43.532 46.4059 43.332 46.2948C42.132 45.6948 40.9209 45.2448 39.6987 44.9448C38.4765 44.6448 37.2431 44.4948 35.9987 44.4948C34.7543 44.4948 33.5209 44.6448 32.2987 44.9448C31.0765 45.2448 29.8654 45.6948 28.6654 46.2948C28.4654 46.4059 28.3043 46.5615 28.182 46.7615C28.0598 46.9615 27.9987 47.1837 27.9987 47.4281V48.4948ZM35.9987 37.8281C36.732 37.8281 37.3598 37.567 37.882 37.0448C38.4043 36.5226 38.6654 35.8948 38.6654 35.1615C38.6654 34.4281 38.4043 33.8003 37.882 33.2781C37.3598 32.7559 36.732 32.4948 35.9987 32.4948C35.2654 32.4948 34.6376 32.7559 34.1154 33.2781C33.5931 33.8003 33.332 34.4281 33.332 35.1615C33.332 35.8948 33.5931 36.5226 34.1154 37.0448C34.6376 37.567 35.2654 37.8281 35.9987 37.8281Z"
        fill="#7D5AE8"
      />
    </g>
  </svg>;
};
export const TickSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <mask id="mask0_4056_66124" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
        <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4056_66124)">
        <path
          d="M8.33333 14.1693L5 10.8359L6.16667 9.66927L8.33333 11.8359L13.8333 6.33594L15 7.5026L8.33333 14.1693Z"
          fill="#303030"
        />
      </g>
    </svg>
  );
};

export const TickSVG2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="16" fill="#DACFFF" />
      <mask id="mask0_8077_27384" maskUnits="userSpaceOnUse" x="4" y="4" width="24" height="24">
        <rect x="4" y="4" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8077_27384)">
        <path d="M14 20.4L10 16.4L11.4 15L14 17.6L20.6 11L22 12.4L14 20.4Z" fill="#7D5AE8" />
      </g>
    </svg>
  );
};

export const PersonAddSVG = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 14" fill="none">
      <path
        d="M15.6312 8.06273C15.233 6.86831 14.2958 5.93105 13.1013 5.53291L12.4987 5.33203L13.1013 5.13115C14.2958 4.73301 15.233 3.79575 15.6312 2.60133L15.832 1.9987L16.0329 2.60133C16.431 3.79575 17.3683 4.73301 18.5627 5.13115L19.1654 5.33203L18.5627 5.53291C17.3683 5.93105 16.431 6.86831 16.0329 8.06273L15.832 8.66536L15.6312 8.06273ZM7.4987 6.9987C6.58203 6.9987 5.79731 6.67231 5.14453 6.01953C4.49175 5.36675 4.16536 4.58203 4.16536 3.66536C4.16536 2.7487 4.49175 1.96398 5.14453 1.3112C5.79731 0.65842 6.58203 0.332031 7.4987 0.332031C8.41536 0.332031 9.20009 0.65842 9.85287 1.3112C10.5056 1.96398 10.832 2.7487 10.832 3.66536C10.832 4.58203 10.5056 5.36675 9.85287 6.01953C9.20009 6.67231 8.41536 6.9987 7.4987 6.9987ZM0.832031 13.6654V11.332C0.832031 10.8598 0.953559 10.4258 1.19661 10.0299C1.43967 9.63411 1.76259 9.33203 2.16536 9.1237C3.02648 8.69314 3.90148 8.37022 4.79036 8.15495C5.67925 7.93967 6.58203 7.83203 7.4987 7.83203C8.41536 7.83203 9.31814 7.93967 10.207 8.15495C11.0959 8.37022 11.9709 8.69314 12.832 9.1237C13.2348 9.33203 13.5577 9.63411 13.8008 10.0299C14.0438 10.4258 14.1654 10.8598 14.1654 11.332V13.6654H0.832031ZM2.4987 11.9987H12.4987V11.332C12.4987 11.1793 12.4605 11.0404 12.3841 10.9154C12.3077 10.7904 12.207 10.6931 12.082 10.6237C11.332 10.2487 10.5751 9.96745 9.8112 9.77995C9.04731 9.59245 8.27648 9.4987 7.4987 9.4987C6.72092 9.4987 5.95009 9.59245 5.1862 9.77995C4.42231 9.96745 3.66536 10.2487 2.91536 10.6237C2.79036 10.6931 2.68967 10.7904 2.61328 10.9154C2.53689 11.0404 2.4987 11.1793 2.4987 11.332V11.9987ZM7.4987 5.33203C7.95703 5.33203 8.34939 5.16884 8.67578 4.84245C9.00217 4.51606 9.16537 4.1237 9.16537 3.66536C9.16537 3.20703 9.00217 2.81467 8.67578 2.48828C8.34939 2.16189 7.95703 1.9987 7.4987 1.9987C7.04036 1.9987 6.648 2.16189 6.32161 2.48828C5.99523 2.81467 5.83203 3.20703 5.83203 3.66536C5.83203 4.1237 5.99523 4.51606 6.32161 4.84245C6.648 5.16884 7.04036 5.33203 7.4987 5.33203Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DocFileSVG = () => {
  return (
    <svg width="32" height="38" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H24L28 4L32 8V34C32 36.2091 30.2091 38 28 38H4C1.79086 38 0 36.2091 0 34V4Z"
        fill="#2E90FA"
      />
      <path d="M24 0L28.5714 4.57143L32 8H24V0Z" fill="#B2DDFF" />
      <mask
        id="mask0_8915_131469"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="9"
        width="20"
        height="20"
      >
        <rect x="6" y="9" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8915_131469)">
        <path
          d="M10.1667 26.5C9.70833 26.5 9.31597 26.3368 8.98958 26.0104C8.66319 25.684 8.5 25.2917 8.5 24.8333V13.1667C8.5 12.7083 8.66319 12.316 8.98958 11.9896C9.31597 11.6632 9.70833 11.5 10.1667 11.5H19.3333L23.5 15.6667V24.8333C23.5 25.2917 23.3368 25.684 23.0104 26.0104C22.684 26.3368 22.2917 26.5 21.8333 26.5H10.1667ZM10.1667 24.8333H21.8333V16.5H18.5V13.1667H10.1667V24.8333ZM11.8333 23.1667H20.1667V21.5H11.8333V23.1667ZM11.8333 16.5H16V14.8333H11.8333V16.5ZM11.8333 19.8333H20.1667V18.1667H11.8333V19.8333Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const AudioFileSVG = () => {
  return (
    <svg width="32" height="38" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H24L28 4L32 8V34C32 36.2091 30.2091 38 28 38H4C1.79086 38 0 36.2091 0 34V4Z"
        fill="#F97066"
      />
      <path d="M24 0L28.5714 4.57143L32 8H24V0Z" fill="#FECDCA" />
      <mask
        id="mask0_8915_132626"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="9"
        width="20"
        height="20"
      >
        <rect x="6" y="9" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8915_132626)">
        <path
          d="M11.8333 23.9974V13.9974H13.5V23.9974H11.8333ZM15.1667 27.3307V10.6641H16.8333V27.3307H15.1667ZM8.5 20.6641V17.3307H10.1667V20.6641H8.5ZM18.5 23.9974V13.9974H20.1667V23.9974H18.5ZM21.8333 20.6641V17.3307H23.5V20.6641H21.8333Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
export const VideoFileSVG = () => {
  return (
    <svg width="32" height="38" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H24L28 4L32 8V34C32 36.2091 30.2091 38 28 38H4C1.79086 38 0 36.2091 0 34V4Z"
        fill="#0E7090"
      />
      <path d="M24 0L28.5714 4.57143L32 8H24V0Z" fill="#CFF9FE" />
      <mask
        id="mask0_8915_129666"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="9"
        width="20"
        height="20"
      >
        <rect x="6" y="9" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_8915_129666)">
        <path
          d="M11.0013 22.3359H17.668V21.8776C17.668 21.2665 17.3624 20.7734 16.7513 20.3984C16.1402 20.0234 15.3346 19.8359 14.3346 19.8359C13.3346 19.8359 12.5291 20.0234 11.918 20.3984C11.3069 20.7734 11.0013 21.2665 11.0013 21.8776V22.3359ZM14.3346 19.0026C14.793 19.0026 15.1853 18.8394 15.5117 18.513C15.8381 18.1866 16.0013 17.7943 16.0013 17.3359C16.0013 16.8776 15.8381 16.4852 15.5117 16.1589C15.1853 15.8325 14.793 15.6693 14.3346 15.6693C13.8763 15.6693 13.4839 15.8325 13.1576 16.1589C12.8312 16.4852 12.668 16.8776 12.668 17.3359C12.668 17.7943 12.8312 18.1866 13.1576 18.513C13.4839 18.8394 13.8763 19.0026 14.3346 19.0026ZM9.33464 25.6693C8.8763 25.6693 8.48394 25.5061 8.15755 25.1797C7.83116 24.8533 7.66797 24.4609 7.66797 24.0026V14.0026C7.66797 13.5443 7.83116 13.1519 8.15755 12.8255C8.48394 12.4991 8.8763 12.3359 9.33464 12.3359H19.3346C19.793 12.3359 20.1853 12.4991 20.5117 12.8255C20.8381 13.1519 21.0013 13.5443 21.0013 14.0026V17.7526L24.3346 14.4193V23.5859L21.0013 20.2526V24.0026C21.0013 24.4609 20.8381 24.8533 20.5117 25.1797C20.1853 25.5061 19.793 25.6693 19.3346 25.6693H9.33464ZM9.33464 24.0026H19.3346V14.0026H9.33464V24.0026Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export const UnCheckedAllIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="4" fill="#7D5AE8" />
      <mask id="mask0_2743_107298" maskUnits="userSpaceOnUse" x="2" y="2" width="16" height="16">
        <rect x="2" y="2" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2743_107298)">
        <path d="M5.3335 10.6667V9.33333H14.6668V10.6667H5.3335Z" fill="white" />
      </g>
    </svg>
  );
};
export const UnCheckedDisabledIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" stroke="#E8E8E8" />
    </svg>
  );
};

export const SearchIcon = ({ color = '#888', width = 20, height = 20 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <title />

      <g id="search">
        <path d="M29.71,28.29l-6.5-6.5-.07,0a12,12,0,1,0-1.39,1.39s0,.05,0,.07l6.5,6.5a1,1,0,0,0,1.42,0A1,1,0,0,0,29.71,28.29ZM14,24A10,10,0,1,1,24,14,10,10,0,0,1,14,24Z" />
      </g>
    </svg>
  );
};
